import React from 'react';
import {FormattedMessage} from "react-intl";
import isFunction from "lodash/isFunction";

import {isTruthy} from "utils/DBUtils";

{/* For when we need to inject some static text into a form */}
class HardcodedText extends React.Component {

    render() {
        
        let showField = true;
        if (this.props.field.showField) {
            if (isFunction(this.props.field.showField)) {
                showField = isTruthy(this.props.field.showField(this.props.formProxy));
            } else {
                showField = this.props.field.showField
            }
        }  


        
        return showField ? (
          <div  className={"hardcoded-text" + (this.props.className ? " " + this.props.className : "")}>
            {this.props.heading ? <h5>{this.props.heading}</h5> : "" }
            {this.props.headingKey ? <FormattedMessage  tagName="h5" id={this.props.headingKey}/> : ""}
            {this.props.text ? <p>{isFunction(this.props.text) ? this.props.text(this.props.formProxy) : this.props.text}</p> : ""}
            {this.props.textKey ? <FormattedMessage tagName="p" id={this.props.textKey}/> : "" }
            { this.props.helperText && <div style={{marginBottom: "6px", fontSize: "14px"}}>{this.props.helperText}</div>}
          </div>
        ) 
        : 
        null
        ;
    }
}

export default HardcodedText;



// WEBPACK FOOTER //
// ./public/components/forms/HardcodedText.jsx